const styles = {
  itemGrid: (order) => ({
    ml: {
      md: order ? 10 : 0,
    },
  }),
  infoContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    mt: 1,
    height: 'fit-content',
  },
  icon: {
    marginTop: '8px',
    alignSelf: 'flex-start',
    width: 28,
    height: 28,
    mr: 2,
    svg: {
      width: '100%',
      height: '100%',
    },
  },
  chip: {
    display: 'flex',
    alignItems: 'center',
    height: '50px',
    ml: 1,
  },
  softChip: {
    display: 'flex',
    alignItems: 'center',
    ml: 1,
    backgroundColor: 'kit.background.middlepurple',
    borderRadius: '4px',
    padding: {
      md: '5px 12px 6px 12px',
      xs: '2px 4px 3px 4px',
    },
  },
};

export default styles;
